import { ENTITY_TYPES } from 'common';

const CREATE_NEW_ENTITIES = [
  { name: ENTITY_TYPES.LEARNING_COMMUNITY.singular, value: ENTITY_TYPES.LEARNING_COMMUNITY.key },
  { name: ENTITY_TYPES.DEPARTMENT.singular, value: ENTITY_TYPES.DEPARTMENT.key },
  { name: ENTITY_TYPES.ORGANIZATION.singular, value: ENTITY_TYPES.ORGANIZATION.key },
];

export default CREATE_NEW_ENTITIES;
